import { Emitter } from "pixi-particles";
import * as Constants from "../Data/Constants";

export enum ConfettiColourSuffixes {
    RED = "-red",
    ORANGE = "-orange",
    YELLOW = "-yellow",
    GREEN = "-green",
    BLUE = "-blue",
    BLACK = "-black",
    WHITE = "",
}

export class ConfettiRain extends PIXI.Container {
    private readonly _particles: Emitter;

    constructor(pColours: ConfettiColourSuffixes[] = [
        ConfettiColourSuffixes.RED,
        ConfettiColourSuffixes.WHITE,
        ConfettiColourSuffixes.ORANGE,
        ConfettiColourSuffixes.GREEN,
        ConfettiColourSuffixes.BLUE,
        ConfettiColourSuffixes.YELLOW,
    ]) {
        super();
        const shapes: string[] = [ "rect", "circle", "tri" ];
        const particles: PIXI.Texture[] = new Array<PIXI.Texture>();
        const sheet: PIXI.loaders.Resource = PIXI.loader.resources[Constants.SPRITESHEET_UI];
        const colours = pColours;
        for (let i = 0; i < colours.length; ++i) {
            for (let j = 0; j < shapes.length; ++j) {
                particles.push(sheet.textures!["particle-confetti-" + shapes[j] + colours[i]]);
            }
        }

        this._particles = new Emitter(
            this,
            particles,
            {
                alpha: {
                    list: [
                        { value: 0.1, time: 0 },
                        { value: 0.8, time: 0.1 },
                        { value: 0.8, time: 0.8 },
                        { value: 0.1, time: 1 },
                    ],
                    isStepped: false,
                },
                speed: {
                    list: [
                        { value: 100, time: 0 },
                    ],
                    isStepped: false,
                    minimumSpeedMultiplier: 0.1,
                },
                acceleration: new PIXI.Point(0, 98),
                // startRotation: { min: 180, max: 360 },
                startRotation: { min: 135, max: 405 },
                rotationSpeed: { min: 0, max: 0 },
                lifetime: { min: 1.5, max: 4.0 },
                frequency: 0.01,
                spawnChance: 1,
                particlesPerWave: 50,
                emitterLifetime: 0.75,
                maxParticles: 200,
                pos: { x: 0, y: 0 },
                addAtBack: false,
                spawnType: "rect",
                spawnRect: { x: -512, y: -10, w: 1024, h: 10 },
            },
        );
        this._particles.emit = false;
    }

    public play(): void {
        this._particles.autoUpdate = true;
        this._particles.emit = true;
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        this._particles.destroy();
        super.destroy(pOptions);
    }
}
